import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { NotificationsService } from '../../pages/settings/service/notifications.service';
import { Notification } from '../../pages/settings/model/notification';
import { BadgeModule } from 'primeng/badge';
import { Popover } from 'primeng/popover';
import { AvatarModule } from 'primeng/avatar';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { Util } from '../util';

@Component({
  selector: 'app-notification',
  standalone: true,
  imports: [
    ToastModule,
    AvatarModule,
    ToastModule,
    TranslateModule,
    BadgeModule,
    Popover,
    ReactiveFormsModule,
    ButtonModule,
    TooltipModule,
  ],
  templateUrl: './notification.component.html',
  styleUrl: './notification.component.scss',
  providers: [MessageService],
})
export class NotificationComponent implements OnInit, OnDestroy {
  notifications: Notification[] = [];
  private pollingSubscription?: Subscription;
  @ViewChild('op') overlayPanel!: Popover;


  constructor(
    private readonly messageService: MessageService,
    private readonly notificationService: NotificationsService,
    private readonly translate: TranslateService,
  ) {}

  ngOnInit(): void {
    this.notificationService.notifications$.subscribe((notifications) => {
      this.notifications = notifications;
    });

    // Démarrer le polling automatique
    this.pollingSubscription = this.notificationService.startPolling(300000); // 5 mn
  }
  ngOnDestroy() {
    if (this.pollingSubscription) {
      this.pollingSubscription.unsubscribe();
    }
  }

  getNotificationIcon(notif: Notification) {
    const type = notif.type.toLowerCase();
    
    if (type === 'error') {
      return 'pi pi-times-circle';
    }
    
    if (type === 'warn') {
      return 'pi pi-exclamation-triangle';
    }
    
    return 'pi pi-info-circle';
}

  getNotifIconColors(notif: Notification) {
    if (notif.type.toLowerCase() === 'error') {
      return {
        'background-color': '#f5c1c1',
        color: '#d12424',
      };
    } else if (notif.type.toLowerCase() === 'warn') {
      return {
        'background-color': '#f2d0aa',
        color: '#b86b14',
      };
    } else {
      return {
        'background-color': '#dee9fc',
        color: '#1a2551',
      };
    }
  }

  deleteNotification(notif: Notification) {
    this.notificationService
      .deleteUserNotification(notif.notificationCode)
      .subscribe({
        next: () => {
          this.overlayPanel.hide();
          this.showSuccessMessage();
        },
        error: () => {
          this.overlayPanel.hide();
          this.showErrorMessage();
        },
      });
  }

  showSuccessMessage() {
   Util.showSuccessMessage(this.messageService, this.translate)
  }
  showErrorMessage() {
    Util.showErrorMessage(this.messageService, this.translate)
  }
}
